import { defineMessages } from 'react-intl'

export const domainsSelectorMessages = defineMessages({
  selectDomain: {
    id: 'domainsSelectorMessages.select',
    description: 'Title/placeholder calling user to select subomain/Group',
    defaultMessage: 'Select Group',
  },
  backToRoot: {
    id: 'domainsSelectorMessages.backToRoot',
    description: 'Title/Hint for a button to back to root Domain/Group',
    defaultMessage: 'Back to {rootDomainName}',
  },
})
